export default __webpack_public_path__ + "static/100--stacked-bar-c75e429350d93c39a9dd83488b38e39d.png";